import { doAttention } from '@/attention';
export function rubberBand(el, duration = undefined, options = {}) {
    return doAttention(el, 'rubberBand', duration, options);
}
//# sourceMappingURL=rubberBand.js.map